<template>
    <a-modal
        centered
        :visible="visible"
        title="修改订单信息"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="order-create" :rules="rules">
        
            <a-form-model-item label="备注">
                <a-textarea v-model="form.remark"></a-textarea>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        remark: null,
        step: null,
        order_no: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                rules: {
                    order_no: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            this.form[v] = this.record[v];
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["order-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.form.type = "confirm";

                        this.$http
                            .put("/order_trademark/" + this.record.order_no, this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    this.$message.success(res.message);

                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },

            after_close() {
                this.$refs["order-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
